import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { _isUserLoggedIn } from 'utils';
import Image1 from 'assets/onboarding/hammerLoadingAd1.png';
import Image2 from 'assets/onboarding/hammerLoadingVal3.png';
import { setLoginSuccessFunction } from 'utils/loginSuccess';

interface Props {
	onLoginSuccess: () => void;
}

export function LoadingPage({ onLoginSuccess }: Props) {
	const navigate = useNavigate();
	const loggedIn = _isUserLoggedIn();

	// Store the function in the singleton
	setLoginSuccessFunction(onLoginSuccess);

	const [randomImage, setRandomImage] = useState<string>();

	useEffect(() => {
		// Preload images and GIFs
		const imagesToPreload = [Image1, Image2];
		imagesToPreload.forEach((src: any) => {
			const img = new Image();
			img.src = src;
		});
	}, []);

	useEffect(() => {
		// Set initial random image on mount
		const loadingImages = [Image1, Image2];
		setRandomImage(
			loadingImages[Math.floor(Math.random() * loadingImages.length)]
		);
	}, []);

	useEffect(() => {
		if (!loggedIn) {
			navigate('/auth/get-started');
		} else {
			onLoginSuccess();
			navigate('/');
		}
		// eslint-disable-next-line
	}, []);

	return (
		<div className="relative max-w-[540px] w-full mx-auto h-screen overflow-hidden loading-page-bg">
			{randomImage && (
				<img
					src={randomImage}
					alt="random loading screen"
					className="absolute"
				/>
			)}
		</div>
	);
}
